import React from "react";

function Dropdown (){
    return <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 7.333 14 0H0z" fill="#000" fill-rule="evenodd"/>
    </svg>
}

export default Dropdown
